var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#community_svg__clip0_21049_64346)",
    fill: "#624DE3"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.238 7.987a2.99 2.99 0 115.979 0 2.99 2.99 0 01-5.979 0zm2.99-4.99a4.99 4.99 0 100 9.979 4.99 4.99 0 000-9.979zM5.737 14.965a4.99 4.99 0 00-4.99 4.99v1.994a1 1 0 102 0v-1.995a2.99 2.99 0 012.99-2.989h6.981a2.99 2.99 0 012.99 2.99v1.994a1 1 0 002 0v-1.995a4.99 4.99 0 00-4.99-4.989H5.737z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.068 9.796l.1-.241a2.274 2.274 0 01.738.493m-.838-.252l.652 3.283a2.012 2.012 0 000-2.846l.186-.185m-.838-.252l.1-.241a2.274 2.274 0 00-2.418.434 2.275 2.275 0 00-3.155 3.276l2.763 2.762a.556.556 0 00.785 0l1.381-1.381 1.382-1.381m-.838-3.469l.838 3.469m0-3.217a2.273 2.273 0 010 3.217s0 0 0 0m0-3.217v3.217m-2.431-2.432h0a1.163 1.163 0 011.645 0h0a1.164 1.164 0 010 1.646h0l-2.37 2.37-2.37-2.37a1.164 1.164 0 111.646-1.646l.332.332a.556.556 0 00.785 0l.331-.332z",
    stroke: "#624DE3",
    strokeWidth: 0.525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "community_svg__clip0_21049_64346"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.75 1.5)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCommunity;